import { ICategory } from "../../models/categories/Category";
import { IChannel } from "../../models/channels/Channel";
import { IImageLink } from "../../models/digitalMedia/ImageLink";
import { IUser } from "../../models/users/User";
import { IChannelViewModel } from "./";


export class ChannelViewModel implements IChannelViewModel {

  /**
   * @method Constructor method
   * @param {IChannel} channel A reference to the underlying Channel object
   * @param {IImageLink | undefined} profileImage If defined, a reference to an associated IImageLink (the Channel Profile image)
   * @param {ICategory | undefined} category A reference to the associated Category object
   * @param {IUser | undefined} ownerUser A reference to the associated Owner User object
   */
  constructor(
    channel: IChannel,
    profileImage?: IImageLink,
    category?: ICategory,
    ownerUser?: IUser
  ) {

    // assign properties from ctor parameters
    this._channel = channel;
    this._profileImage = profileImage;
    this._category = category;
    this._ownerUser = ownerUser;
  }


  /*-----------------------------------------------*/
  /**
   * @property {IChannel} _channel A reference to the underlying Channel object
   */
  private _channel: IChannel;

  /**
   * @method channel Getter method for _channel
   */
  get channel(): IChannel {
    return this._channel;
  }

  /**
   * @method channel Setter method for _channel
   * @param {IChannel} value The input value for setting _channel
   */
  set channel(value: IChannel) {
    this._channel = value;
  }
  /*-----------------------------------------------*/

  /*-----------------------------------------------*/
  /**
   * @property {IImageLink | undefined} _profileImage If defined, a reference to an associated IImageLink (the Channel Profile image)
   */
  private _profileImage: IImageLink | undefined = undefined;

  /**
   * @method profileImage Getter method for _profileImage
   */
  get profileImage(): IImageLink | undefined {
    return this._profileImage;
  }

  /**
   * @method profileImage Setter method for _profileImage
   * @param {IImageLink | undefined} value The input value for setting _profileImage
   */
  set profileImage(value: IImageLink | undefined) {
    this._profileImage = value;
  }
  /*-----------------------------------------------*/

  /*-----------------------------------------------*/
  /**
   * @property {ICategory | undefined} _category A reference to the associated Category object
   */
  private _category: ICategory | undefined = undefined;

  /**
   * @method category Getter method for _category
   */
  get category(): ICategory | undefined {
    return this._category;
  }

  /**
   * @method category Setter method for _category
   * @param {ICategory | undefined} value The input value for setting _category
   */
  set category(value: ICategory | undefined) {
    this._category = value;
  }
  /*-----------------------------------------------*/

  /*-----------------------------------------------*/
  /**
   * @property {IUser | undefined} _ownerUser A reference to the associated Owner User object
   */
  private _ownerUser: IUser | undefined = undefined;

  /**
   * @method ownerUser Getter method for _ownerUser
   */
  get ownerUser(): IUser | undefined {
    return this._ownerUser;
  }

  /**
   * @method ownerUser Setter method for _ownerUser
   * @param {IUser | undefined} value The input value for setting _ownerUser
   */
  set ownerUser(value: IUser | undefined) {
    this._ownerUser = value;
  }
  /*-----------------------------------------------*/

}